<template>
    <div class="ui-filter-dropdown-2" v-if="permission_creator.disableCreators.permission || permission_creator.addOrEditCreatorTags.permission">
        <div class="ui-filter-dropdown-2--inner">
            <el-button class="ui-filter-btn ui-button" :class="{ 'disabled': disabled }"
                @click.stop="is_show_select = !is_show_select;">
                <svg-icon name="arrow" />
                <span>Edit</span>
            </el-button>

            <div>
               
                <ul v-if="is_show_select" class="item-box" >
                    <Scrollbar class="scroll-inner">
                        <li :class="{'item': true , 'item-dis':disabled_status ,}" @mouseover="main_index = 0 " v-if="permission_creator.disableCreators.permission">
                            <tippy content="Select one or more creators to edit their account status." class="flex">
                                <span>Account Status</span>
                                <svg-icon name="next" />
                            </tippy>
                        </li>
                        <li class="item" :class="{ 'selected': main_index === 1 }" @mouseover="main_index = 1;" v-if="permission_creator.addOrEditCreatorTags.permission">
                            <tippy content="Select one or more creators to edit their creator tag." class="flex">
                                <span>Tags</span>
                                <svg-icon name="next"/>
                            </tippy>
                        </li>
                        <li :class="{'item': true, 'selected': main_index === 2, 'item-dis': disabled_status}" @mouseover="main_index = 2" v-if="!hide_account_type">
                            <span>Account Type</span>
                            <svg-icon name="next"/>
                        </li>

                    </Scrollbar>
                </ul>

                <ul v-if="is_show_select && main_index === 0 && permission_creator.disableCreators.permission" class="item-box sub">
                    <Scrollbar class="scroll-inner">
                        <Scrollbar class="scroll-inner">
                            <li :class="['item', v.disabled && 'disabled']" v-for="(v,k) in status_items" :key="k" @click="handleItemClick($event, v)">
                                <span>{{ v.text }}</span>
                            </li>
                        </Scrollbar>
                    </Scrollbar>
                </ul>
                <ul v-if="is_show_select && main_index === 2 && !hide_account_type" class="item-box sub" style="top: 108px;">
                    <Scrollbar class="scroll-inner">
                        <Scrollbar class="scroll-inner">
                            <li :class="['item', v.disabled && 'disabled']" v-for="(v,k) in account_type_items" :key="k" @click="handleAccountTypeClick($event, v)">
                                <span>{{ v.text }}</span>
                            </li>
                        </Scrollbar>
                    </Scrollbar>
                </ul>
                <ul v-show="is_show_select && main_index === 1" class="item-box sub sub-spec">
                    <DropdownHashtag class="tag_top_drop" :tags="tags" :selected_tags="selected_cre_tags"
                        :tag_type="'creator_tag'"
                        :disabled_check="disabled_status"
                        :row="row"
                        :spec_tag="true"
                        :outside_remove="true"
                        @select-tag="selectTag" :open_key="is_show_select" 
                        />
                </ul>

            </div>

        </div>
    </div>
</template>

<script>
import Button from '@/components/ui/Button.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import DropdownHashtag from '@/components/DropdownHashtag.vue';
import { ElButton } from 'element-plus';

export default {
    name: 'Dropdown',
    emits: ['remove','resetRemove','status_pick','update','account_type_pick'],

    components: {
        Button,
        Scrollbar,
        DropdownHashtag,
        ElButton,
    },

    data() {
        return {
            is_show_select: false,
            main_index: null,
            selected_cre_tags:[],
        }
    },

    props: {
        disabled_status:{
            type: Boolean,
            default: false,
        },
        
        status_items:{
            type: Array,
            default: () => [],
        },

        tags:{
            type: Array,
            default: () => [],
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        row:{
            type: Array,
            default: () => [],
        },

        account_type_items:{
            type: Array,
            default: () => [],
        },

        hide_account_type:{
            type: Boolean,
            default: false,
        },


    },

    computed: {
        permission_creator(){
            return this.$store.state.user_data?.permission_list?.creatorManagement;
        }
    },

    watch:{
        is_show_select(val){
            this.$store.state.spec_value.list_status_open=val;
            console.log('this.$store.state.spec_value.list_status_open',this.$store.state.spec_value.list_status_open)
            if(!val){
                this.selected_cre_tags=[];
            }else{
                this.findSameTag()
            }
        },

        '$store.state.spec_value.list_tag_open': {
            handler(val) {
                if(val && this.is_show_select){
                    this.is_show_select = false;
                }
            },
            deep: true  // 深度监听
        },
        '$store.state.spec_value.list_filter_open': {
            handler(val) {
                if(val && this.is_show_select){
                    this.is_show_select = false;
                }
            },
            deep: true  // 深度监听
        },

    },

    methods: {
        findSameTag(){
            let commonTags = [];

            // 初始化，使用第一個 row 的 merchant_account_tags 作為基準進行交集比對
            let commonTagIds = this.row[0]?.merchant_account_tags.map(tag => tag.tag_id) || [];

            // 遍歷剩下的 row，取交集
            this.row.forEach(rowItem => {
                let tagIds = rowItem.merchant_account_tags.map(tag => tag.tag_id);
                commonTagIds = commonTagIds.filter(tag_id => tagIds.includes(tag_id)); // 交集
            });

            // 遍歷交集結果，重組保留所有原始欄位的物件陣列
            commonTagIds.forEach(tag_id => {
                // 找出任一 row 中的符合 tag_id 的完整物件
                let matchingTag = this.row[0].merchant_account_tags.find(tag => tag.tag_id === tag_id);
                
                if (matchingTag) {
                    // 深拷貝原物件，並新增 id 欄位
                    let newTagObject = { ...matchingTag, id: tag_id };
                    commonTags.push(newTagObject);
                }
            });
            this.selected_cre_tags=commonTags;
 
        },

        selectTag(item){
            const index = this.selected_cre_tags.findIndex((t) => t.id === item.tag.id);
            if (index === -1) {
                this.selected_cre_tags.push(item.tag);
            } else {
                this.selected_cre_tags.splice(index, 1);
            }
            this.$emit('update');
        },

        handleItemClick(e, v) {
            if (v.disabled) e.stopPropagation();
            this.$emit('status_pick', v);
        },

        handleAccountTypeClick(e, v) {
            if (v.disabled) {
                e.stopPropagation();
                return;
            }
            this.$emit('account_type_pick', v);
        },

        handleClick(e) {
            this.is_show_select = false;
            this.main_index=null;
        },

    },

    mounted() {

    },

    created() {
        window.addEventListener('click', this.handleClick);
    },

    destroyed() {
        window.removeEventListener('click', this.handleClick);
    },

}
</script>
<style lang="scss">

.ui-filter-dropdown-2 {
    .flex{
        display: flex;
        align-items: center;
    }

    &--inner {
        position: relative;

        .ui-filter-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            span {
                font: var(--font-fg-12);
                color: var(--black-60);
            }

            svg {
                width: 8px !important;
                height: 8px !important;
                margin-right: 6px !important;
                // margin-right: 5px;
                color: black !important;
            }

            &.disabled {
                border: 1px solid var(--black-10);
                cursor: not-allowed;

                span {
                    color: var(--black-40);
                }

                svg {
                    fill: var(--black-40);
                }
            }
        }


        &.hide-popup>ul,
        &.hide-popup>div {
            display: none !important;
        }

        .scroll-inner {
            height: 100%;
            overflow: auto;
        }

        .item-box {
            padding: 8px 0;
            // width: 238px;
            width: 150px;
            background: white;
            border: 1px solid #F2F2F2;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            border-radius: 6px 0 0 6px;
            position: absolute;
            z-index: 11;
            height:auto;
            max-height: 40vh;

            &.sub {
                left: 150px;
                border-radius: 0 6px 6px 0;

                .item>svg {
                    width: 14px;
                    height: 14px;
                    margin-right: 6px !important;
                    fill: var(--dark-blue);
                }
            }

            &.sub-spec{
                width:0;
                padding: 0;
            }

            &.direction--right {
                right: 0px;
            }

            .item {
                padding: 9px 10px;
                display: flex;
                align-items: center;
                cursor: pointer;
                color: var(--black-60);
                font: var(--font-fg-12);

                &.sub {
                    padding-left: 20px;
                }

                span {
                    flex: 1;
                }

                &:hover,
                &.selected {
                    background: var(--bg-02);
                    color: var(--dark-blue);
                    font: var(--font-fg-12);

                    &.metric {
                        svg {
                            transform: rotate(90deg);
                        }
                    }
                }

                &.item-dis{
                    color:var(--black-40);
                    cursor: not-allowed;
                }

                &.item-dis:hover{
                    color:var(--black-40);
                }

                &.disabled {
                    color: var(--black-40);
                    cursor: not-allowed;

                    .select-icon {
                        border: 1px solid var(--black-40);
                    }
                }

                svg {
                    width: 8px;
                    height: 8px;
                    margin-right: unset !important;
                    fill: var(--dark-blue);
                }

                .select-icon {
                    width: 14px;
                    height: 14px;
                    margin-right: 6px;
                    border: 1px solid var(--black-50);
                    border-radius: 50%;
                    background-color: white;
                }
            }

        }

        .dropdown-hashtag{
            position: relative;
            top:0;
        }

        .btns{
            &:first-child{
                margin-right: 8px;
            }
        }
    }
}
</style>
